import { gql } from '@apollo/client';

export default gql`
  query inspections(
    $placeId: ID
    $inspectionSubjectId: ID
    $sortBy: String
    $name: String
    $bucket: String
    $page: Int
    $dueDateFrom: ISO8601DateTime
    $dueDateTo: ISO8601DateTime
    $doneAtFrom: ISO8601DateTime
    $doneAtTo: ISO8601DateTime
    $canceledAtFrom: ISO8601DateTime
    $canceledAtTo: ISO8601DateTime
    $notConditions: NotConditionsInput
    $inspectorId: ID
    $search: String
  ) {
    space {
      overInspectionsLimit
      adminRole
    }
    inspections(
      placeId: $placeId
      inspectionSubjectId: $inspectionSubjectId
      sortBy: $sortBy
      name: $name
      bucket: $bucket
      page: $page
      dueDateFrom: $dueDateFrom
      dueDateTo: $dueDateTo
      doneAtFrom: $doneAtFrom
      doneAtTo: $doneAtTo
      canceledAtFrom: $canceledAtFrom
      canceledAtTo: $canceledAtTo
      inspectorId: $inspectorId
      notConditions: $notConditions
      search: $search
    ) {
      perPage
      hasNextPage
      inspectionsTotalPages
      inspectionsTotal
      inspections {
        id
        dueDate
        doneAt
        canceledAt
        periodCycle
        periodNumber
        name
        result
        overdue
        incoming
        canceled
        inspectionResultsTotal
        inspectionSubject {
          id
          name
          serialNumber
          brand
          model
        }
        place {
          id
          name
          street
          city
          zipCode
        }
      }
    }
  }
`;
